import { defineMessages } from 'react-intl';


const HOME_INSURANCE_QUOTE_LAUNCHER_MESSAGES = defineMessages({
    INVALID_COMBINATION: {
        id: 'insurance.inlineForm.nothingForThisProvince',
        defaultMessage: 'Sorry, we don\'t service this region',
    },
    SELECT_HOME: {
        id: 'insurance.homeInsuranceQuoteLauncher.home',
        defaultMessage: 'Home',
    },
    SELECT_CONDO: {
        id: 'insurance.homeInsuranceQuoteLauncher.condo',
        defaultMessage: 'Condo',
    },
    SELECT_TENANT: {
        id: 'insurance.homeInsuranceQuoteLauncher.tenant',
        defaultMessage: 'Tenant',
    },
});

export default HOME_INSURANCE_QUOTE_LAUNCHER_MESSAGES;
